import {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {change} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';

/**
 * A component for generating rows of ProductUnitCheckRows
 *
 */
class ProductUnitCheck extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultProductUnit: null,
            productUnits: [],
        };
        this.handleProductUnitList = this.handleProductUnitList.bind(this);
    }

    componentWillMount() {
        if (this.props.record) {
            this.props.dispatch(change('record-form', 'parent_default_unit', null));
            this.props.dispatch(change('record-form', 'parent_product_units', null));
            this.fetchProductUnits();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.productId !== this.props.productId) {
            this.fetchProductUnits();
        }
    }

    /**
     * Get Product Units for the current Product Unit's parent Product
     */
    fetchProductUnits() {
        const id = (this.props.productId) ? this.props.productId : this.props.record.id;
        const params = {
            filter: {
                type: this.props.record.type,
                id: id
            },
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        const resource = productResources.ProductUnitsByTypeProductId.GET_LIST(params);

        // Retrieve the data and assign results to the Select choices
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    let payload = null;
                    if (result.data.payload) {
                        payload = result.data.payload;
                    }
                    this.handleProductUnitList(payload);
                }).catch((error) => {
                    let message = '';
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                        if (error.response.data.error_message) {
                            message = error.response.data.error_message;
                            console.log('Error: ' + message);
                        }
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                    this.handleProductUnitList(null);
                });
            });
    }

    /**
     * Dispatch list of Product Units
     *
     * @param list
     */
    handleProductUnitList = (list) => {
        let defaultProductUnit = null;
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                if (list[i].default_unit && list[i].default_unit === true) {
                    defaultProductUnit = list[i];
                    break;
                }
            }
        }
        this.setState({
            defaultProductUnit: defaultProductUnit,
            productUnits: list
        });

        this.props.onProductUnitList(list, defaultProductUnit);
        this.props.dispatch(change('record-form', 'parent_default_unit', defaultProductUnit));
        this.props.dispatch(change('record-form', 'parent_product_units', list));

        if (defaultProductUnit !== null && defaultProductUnit.id !== this.props.record.id) {
            this.props.dispatch(change('record-form', 'default_unit', false));
            this.props.dispatch(change('record-form', 'piece_unit', defaultProductUnit.id));
        }
    };

    render() {
        return null
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        const defaultProductUnit = (form.values['parent_default_unit']) ? form.values['parent_default_unit'] : null;
        const productId = (form.values['product_id']) ? form.values['product_id'] : null;
        const productUnits = (form.values['parent_product_units']) ? form.values['parent_product_units'] : [];

        return {
            defaultProductUnit: defaultProductUnit,
            productId: productId,
            productUnits: productUnits
        }
    }
    return {
        defaultProductUnit: null,
        productId: null,
        productUnits: []
    }
};

ProductUnitCheck.propTypes = {
    addField: PropTypes.bool,
    onProductUnitList: PropTypes.func,
    productUnits: PropTypes.array,
    record: PropTypes.object
};

ProductUnitCheck.defaultProps = {
    addField: true,
    productUnits: [],
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(ProductUnitCheck);



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductUnitCheck.js